export default __webpack_public_path__ + "static/media/coinMarketCap.cc0d36df.png";